import { createPermission } from '@backstage/plugin-permission-common';

// ACCOUNT SAS PERMISSIONS
const storageAccountSASCreateName = 'storageaccount.sas.create';

export const storageAccountSASCreatePermissionDv = createPermission({
  name: `${storageAccountSASCreateName}.dv`,
  attributes: { action: 'create' },
});

export const storageAccountSASCreatePermissionPp = createPermission({
  name: `${storageAccountSASCreateName}.pp`,
  attributes: { action: 'create' },
});

export const storageAccountSASCreatePermissionPr = createPermission({
  name: `${storageAccountSASCreateName}.pr`,
  attributes: { action: 'create' },
});

// CONTAINER SAS PERMISSIONS
const storageContainerSASCreateName = 'storageaccount.container-sas.create';

export const storageContainerSASCreatePermissionDv = createPermission({
  name: `${storageContainerSASCreateName}.dv`,
  attributes: { action: 'create' },
});

export const storageContainerSASCreatePermissionPp = createPermission({
  name: `${storageContainerSASCreateName}.pp`,
  attributes: { action: 'create' },
});

export const storageContainerSASCreatePermissionPr = createPermission({
  name: `${storageContainerSASCreateName}.pr`,
  attributes: { action: 'create' },
});

// QUEUE CLEAR PERMISSIONS
const queueClear = 'storageaccount.queue.clear';

export const storageAccountQueueClearPermissionDv = createPermission({
  name: `${queueClear}.dv`,
  attributes: { action: 'update' },
});

export const storageAccountQueueClearPermissionPp = createPermission({
  name: `${queueClear}.pp`,
  attributes: { action: 'update' },
});

export const storageAccountQueueClearPermissionNp = createPermission({
  name: `${queueClear}.np`,
  attributes: { action: 'update' },
});

export const storageAccountPermissions = [
  storageAccountSASCreatePermissionDv,
  storageAccountSASCreatePermissionPp,
  storageAccountSASCreatePermissionPr,

  storageContainerSASCreatePermissionDv,
  storageContainerSASCreatePermissionPp,
  storageContainerSASCreatePermissionPr,

  storageAccountQueueClearPermissionDv,
  storageAccountQueueClearPermissionPp,
  storageAccountQueueClearPermissionNp,
];
